import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DxChartComponent } from 'devextreme-angular';
import {
  DxiConstantLineComponent,
  DxiSeriesComponent,
  DxoExportComponent,
  DxoLabelComponent,
  DxoLegendComponent,
  DxoSubtitleComponent,
  DxoTitleComponent,
  DxoValueAxisComponent,
} from 'devextreme-angular/ui/nested';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';

@Component({
  selector: 'app-chart-bar-consumi-mensili-articolo',
  templateUrl: './chart-bar-consumi-mensili-articolo.component.html',
  styleUrls: ['./chart-bar-consumi-mensili-articolo.component.scss'],
  imports: [
    DxChartComponent,
    DxoValueAxisComponent,
    DxoSubtitleComponent,
    DxoTitleComponent,
    DxoExportComponent,
    DxoLegendComponent,
    DxoLabelComponent,
    DxiConstantLineComponent,
    DxiSeriesComponent,
  ],
})
export class ChartBarConsumiMensiliArticoloComponent
  extends GestArticoliBaseComponent
  implements OnChanges
{
  @Input() consegneMensili;

  totConsegne: number;
  titleChart: string;
  mediaValori: string;

  ngOnChanges(changes: SimpleChanges) {
    const consegneChanged =
      changes['consegneMensili'] &&
      changes['consegneMensili'].currentValue !==
        changes['consegneMensili'].previousValue;

    // const articoloChanged =
    //   changes['idArticolo'] &&
    //   changes['idArticolo'].currentValue !==
    //     changes['idArticolo'].previousValue;

    if (consegneChanged) {
      this.calcoloMedia();
    }
  }

  calcoloMedia() {
    const valori = this.consegneMensili.map((x) => x.val);
    const somma = valori.reduce((a, b) => a + b, 0);
    this.mediaValori = (somma / valori.length).toFixed(2);
    this.titleChart = 'Consegne annuali (' + somma + ')'; //Titolo grafico
  }
}
